import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminSellers = () => {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get('/api/platform_admin/sellers', {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setResult(Array.isArray(res.data.result) ? res.data.result : []);
      } else if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      console.error('셀러 목록 로드 실패:', err);
      setResult([]);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  const handleDelete = async (id) => {
    const ok = window.confirm('정말 삭제하시겠습니까?');
    if (!ok) return;

    try {
      const res = await axios.get(`/api/platform_admin/seller_delete?id=${encodeURIComponent(id)}`, {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      if (err.response && err.response.data && err.response.data.msg) {
        alert(err.response.data.msg);
        return;
      }

      console.error('셀러 삭제 실패:', err);
      alert('삭제 중 오류가 발생했습니다.');
    }
  };

  const formatDateTime = (value) => {
    if (!value) return '-';
    const s = String(value).replace('T', ' ');
    return s.slice(0, 19);
  };

  return (
    <div className="bg-light min-vh-100">
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light active me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>👤 셀러 관리</h4>
          <a href="/platform_admin/seller_add" className="btn btn-primary">
            + 새 셀러 추가
          </a>
        </div>

        <div className="card shadow-sm">
          <div className="card-body p-0">
            <table className="table table-bordered table-hover mb-0 align-middle">
              <thead className="table-light">
                <tr className="text-center">
                  <th style={{ width: '80px' }}>ID</th>
                  <th>판매자명</th>
                  <th style={{ width: '160px' }}>등록일</th>
                  <th>연결된 상점</th>
                  <th style={{ width: '160px' }}>액션</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-4">
                      불러오는 중...
                    </td>
                  </tr>
                ) : result.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center py-4">
                      등록된 셀러가 없습니다.
                    </td>
                  </tr>
                ) : (
                  result.map((row) => (
                    <tr className="text-center" key={row.id}>
                      <td>{row.id}</td>
                      <td className="text-start px-3">{row.username}</td>
                      <td>{formatDateTime(row.created_at)}</td>
                      <td className="text-start px-3">{row.shop_name}</td>
                      <td>
                        <a
                          href={`/platform_admin/seller_edit?id=${row.id}`}
                          className="btn btn-sm btn-warning me-2"
                        >
                          수정
                        </a>
                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(row.id)}
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminSellers;